<template>
  <div
    v-if="hasCounties"
    class="pagetext-content container mx-auto flex flex-col py-3"
  >
    <div class="mx-4">
      <h2 class="search-title">
        {{ searchTitle }}
      </h2>
      <div class="horizontal-separator"></div>
      <ul class="mb-2 md:columns-3">
        <template v-for="country in Object.keys(page_counties)">
          <li>
            <h2 class="text-lg leading-10 text-blue-30">{{ country }}</h2>
          </li>
          <li v-for="county in page_counties[country]">
            <static-search-link
              class="leading-10 text-blue-30"
              :key="county.url"
              :to="county.url"
              :title="county.title"
            >
              {{ county.title }}
            </static-search-link>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import StaticSearchLink from 'Components/StaticSearchLink';

export default {
  name: 'IndustryCountyLinks',
  components: {
    StaticSearchLink,
  },
  computed: {
    ...mapState('pagetext', ['pagetype', 'page_counties', 'industry']),
    ...mapGetters('pagetext', ['getPageType']),
    hasCounties() {
      return (
        this.getPageType == 'industry' &&
        Object.keys(this.page_counties).length > 0
      );
    },
    searchTitle() {
        let s = "Most Popular Locations for " + this.industry.industry_name_1;
        if (this.shouldSwitchHeadingTag()) {
            s = s + " recruitment";
        }
        return s;
    }

  },
};
</script>
